// extracted by mini-css-extract-plugin
export default {"container":"SharedPhoto_container_c30H2","item":"SharedPhoto_item_oW02F","image":"SharedPhoto_image_Zc2oV","infiniteLoading":"SharedPhoto_infiniteLoading_ChpKf"};